import * as React from "react";
import Header from "../components/header";
import MiscCategories from "../components/miscCategories";
import Footer from "../components/footer";

const MiscPage = () => {
  return (
    <main style={{ backgroundColor: "#0a0a0a", minHeight: "100vh", color: "#fff" }}>
      <Header />
      <MiscCategories />
      <Footer />
    </main>
  );
};

export default MiscPage;